module.exports = __webpack_public_path__ + "img/sampleballot_large.ad6ba05d.png";